(() => {
  if (window.__neoniifyCartPreviewBound) return;
  window.__neoniifyCartPreviewBound = true;

  const waitForRenderer = () =>
    new Promise((resolve, reject) => {
      if (window.NeoniifyPreview?.render) {
        resolve(window.NeoniifyPreview);
        return;
      }
      const started = Date.now();
      const timer = window.setInterval(() => {
        if (window.NeoniifyPreview?.render) {
          window.clearInterval(timer);
          resolve(window.NeoniifyPreview);
          return;
        }
        if (Date.now() - started > 8000) {
          window.clearInterval(timer);
          reject(new Error("NeoniifyPreview.render is not available"));
        }
      }, 30);
    });

  async function initializeNeoniifyCartPreviews(root = document) {
    const scope = root && root.querySelectorAll ? root : document;
    const renderer = await waitForRenderer();
    renderer.ensureFontsStylesheet?.();
    const elements = [...scope.querySelectorAll(".neoniify-cart-preview:not([data-preview-ready])")];

    if (/\bneoniifyDebug=1\b/.test(location.search) && !window.__neoniifyPreviewDebugOnce) {
      window.__neoniifyPreviewDebugOnce = true;
      console.table({
        previewElements: document.querySelectorAll(".neoniify-cart-preview").length,
        rendererAvailable: typeof window.NeoniifyPreview,
        initializerAvailable: typeof window.initializeNeoniifyCartPreviews,
      });
      document.querySelectorAll(".neoniify-cart-preview").forEach((element) => {
        console.log({
          text: element.dataset.text,
          font: element.dataset.font,
          color: element.dataset.color,
          size: element.dataset.size,
          background: element.dataset.background,
          width: element.offsetWidth,
          height: element.offsetHeight,
        });
      });
    }

    for (const element of elements) {
      if (element.dataset.previewPending === "true") continue;
      element.dataset.previewPending = "true";
      try {
        const configuration = {
          text: element.dataset.text || "",
          t: element.dataset.text || "",
          font: element.dataset.font || "Passionate",
          f: element.dataset.font || "Passionate",
          color: element.dataset.color || "White",
          c: element.dataset.color || "White",
          size: element.dataset.size || "Small",
          s: element.dataset.size || "Small",
          background: element.dataset.background || "",
          bg: element.dataset.background || "",
          version: element.dataset.previewVersion || "1",
          v: element.dataset.previewVersion || "1",
        };

        const canvasHost = element.querySelector(".neoniify-cart-preview__canvas") || element;
        const ok = await renderer.render(canvasHost, configuration);
        if (!ok) {
          throw new Error("NeoniifyPreview.render returned false");
        }
        element.dataset.previewReady = "true";
      } catch (error) {
        element.dataset.previewPending = "";
        console.error("Neoniify cart preview failed:", error, {
          text: element.dataset.text,
          font: element.dataset.font,
          color: element.dataset.color,
          size: element.dataset.size,
          background: element.dataset.background,
          width: element.offsetWidth,
          height: element.offsetHeight,
        });
      }
    }
  }

  const scheduleNeoniifyCartPreviews = (root) => {
    const run = () => {
      initializeNeoniifyCartPreviews(root || document).catch((error) => {
        console.error("Neoniify cart preview failed:", error);
      });
    };
    requestAnimationFrame(() => {
      requestAnimationFrame(run);
      window.setTimeout(run, 60);
      window.setTimeout(run, 320);
    });
  };

  window.initializeNeoniifyCartPreviews = initializeNeoniifyCartPreviews;
  window.scheduleNeoniifyCartPreviews = scheduleNeoniifyCartPreviews;

  const hydrate = (root) => scheduleNeoniifyCartPreviews(root || document);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => hydrate(), { once: true });
  } else {
    hydrate();
  }

  document.addEventListener("shopify:section:load", (event) => hydrate(event.target));
  window.addEventListener("pageshow", () => hydrate());

  if (window.subscribe && window.PUB_SUB_EVENTS) {
    const refresh = () => hydrate(document);
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh);
    if (window.PUB_SUB_EVENTS.quantityUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.quantityUpdate, refresh);
    }
  }

  const observed = new Set();
  const observeCartRoots = () => {
    document
      .querySelectorAll("cart-items, cart-drawer, cart-notification, #cart-notification-product, #CartDrawer")
      .forEach((node) => {
        if (!node || observed.has(node)) return;
        observed.add(node);
        let queued = false;
        const observer = new MutationObserver(() => {
          if (queued || !node.querySelector(".neoniify-cart-preview:not([data-preview-ready])")) return;
          queued = true;
          requestAnimationFrame(() => {
            queued = false;
            hydrate(node);
          });
        });
        observer.observe(node, { childList: true, subtree: true });
      });
  };

  observeCartRoots();
  document.addEventListener("shopify:section:load", observeCartRoots);
})();
